var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformacoesPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 24,
    height: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    x: 10.8,
    y: 6,
    fill: "#000",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 7.2,
    x: 10.8,
    y: 10.8,
    fill: "#000",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 12C0 5.37258148 5.3725586 0 12 0s12 5.37258148 12 12-5.3725586 12-12 12S0 18.62741852 0 12zm2.40002441 0c0 5.30193329 4.2980957 9.6000061 9.59997559 9.6000061C17.2989502 21.59272766 21.59277344 17.29891968 21.59997559 12c0-5.30193329-4.29797364-9.59999847-9.59997559-9.59999847-5.30187988 0-9.59997559 4.29806518-9.59997559 9.59999847z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacoesPreto);
export default __webpack_public_path__ + "static/media/informacoesPreto.dd690e06a464ec34b6e1c28539555785.svg";
export { ForwardRef as ReactComponent };